// extracted by mini-css-extract-plugin
export var bold = "_yf-0";